/* --- Guard: prevent third-party/init errors from breaking product media --- */
(function () {
  var safeDocReady = function (fn) {
    try { fn(); } catch (e) { console.warn('[safeDocReady]', e); }
  };

  window.shuffleProducts = window.shuffleProducts || function () { /* no-op */ };

  var _add = document.addEventListener;
  document.addEventListener = function (type, fn, opt) {
    if (type === 'DOMContentLoaded' && typeof fn === 'function') {
      return _add.call(document, type, function(){ safeDocReady(fn); }, opt);
    }
    return _add.call(document, type, fn, opt);
  };
})();
document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant?.featured_image) return;

  const container = document.querySelector('.product__media-list');
  const items = [...container.children];

  const match = items.find(item =>
    item.querySelector('img')?.src.includes(variant.featured_image.src.split('/').pop())
  );

  if (match) container.prepend(match);
});
document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant || !variant.featured_media) return;

  const mediaId = variant.featured_media.id;
  const container = document.querySelector('.product__media-list');
  if (!container) return;

  const items = [...container.querySelectorAll('[data-media-id]')];

  const match = items.find(item =>
    item.dataset.mediaId == mediaId
  );

  if (!match) return;

  // Delay to beat theme re-init
  setTimeout(() => {
    container.prepend(match);
  }, 150);
});

document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const searchTerm = params.get('q');

  if (!searchTerm) return;

  // Wait for search results to render (important for infinite scroll)
  setTimeout(() => {
    document.querySelectorAll('[data-product-json]').forEach(card => {
      let productData;

      try {
        productData = JSON.parse(card.getAttribute('data-product-json'));
      } catch (e) {
        return;
      }

      if (!productData.variants) return;

      const matchedVariant = productData.variants.find(
        v => v.sku && v.sku.toLowerCase() === searchTerm.toLowerCase()
      );

      if (!matchedVariant || !matchedVariant.featured_image) return;

      // Update image
      const img = card.querySelector('img');
      if (img) {
        img.src = matchedVariant.featured_image.src;
        img.srcset = '';
      }

      // Update product link
      const link = card.querySelector('a');
      if (link && !link.href.includes('variant=')) {
        link.href = `${link.href}?variant=${matchedVariant.id}`;
      }
    });
  }, 600);
});

(function () {
  function updateDiscount(discountValue) {
    if (!discountValue) return;
    const numericDiscount = parseFloat(discountValue);
    if (Number.isNaN(numericDiscount)) {
      console.warn("Invalid discount value:", discountValue);
      return;
    }
    const decimalPart = numericDiscount - Math.floor(numericDiscount);
    const roundedDiscount =
      decimalPart < 0.5 ? Math.floor(numericDiscount) : Math.ceil(numericDiscount);

    const discountText = `-${roundedDiscount}%`;
    document.querySelectorAll(".pro-img-discount").forEach((p) => {
      p.textContent = discountText;
    });
  }

  function initPDP() {
    const colorButtons = document.querySelectorAll(".product__color-swatch");
    if (!colorButtons.length) return;

    const imageButtons = document.querySelectorAll(".product-thumbnails__item-link");

    // Modified: don’t hide videos
    function filterThumbnailsByValue(selectedValue) {
      if (!imageButtons.length) return;

      let matches = 0;
      const normalizedSelected = (selectedValue || "").trim().toLowerCase();

      imageButtons.forEach((btn) => {
        const alt =
          (btn.getAttribute("thumbnail-alt") ||
            btn.getAttribute("data-thumbnail-alt") ||
            "")
            .trim()
            .toLowerCase();

        const mediaType = btn.getAttribute("data-media-type");
        const isVideo = mediaType === "video" || mediaType === "external_video";

        const isMatch = normalizedSelected && alt && alt === normalizedSelected;

        if (isMatch || isVideo) {
          btn.style.display = "block";
          if (btn.parentElement) btn.parentElement.style.display = "block";
          if (isMatch) matches++;
        } else {
          btn.style.display = "none";
          if (btn.parentElement) btn.parentElement.style.display = "none";
        }
      });

      // Fallback: show all if nothing matched
      if (matches === 0) {
        imageButtons.forEach((btn) => {
          btn.style.display = "block";
          if (btn.parentElement) btn.parentElement.style.display = "block";
        });
      }
    }

    colorButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        const selectedValue =
          btn.getAttribute("data-option-value") ||
          btn.dataset.optionValue ||
          btn.textContent ||
          "";

        filterThumbnailsByValue(selectedValue);

        const disValue = btn.getAttribute("dis") || btn.dataset.dis;
        updateDiscount(disValue);
      });
    });

    const urlVariant = new URL(window.location.href).searchParams.get("variant");
    if (urlVariant) {
      setTimeout(() => {
        let found = false;
        colorButtons.forEach((btn) => {
          if (btn.getAttribute("var-id") === urlVariant) {
            found = true;
            const disValue = btn.getAttribute("dis") || btn.dataset.dis;
            updateDiscount(disValue);
            btn.click();
          }
        });
        if (!found) {
          console.warn("No matching variant found for ID:", urlVariant);
          imageButtons.forEach((btn) => {
            btn.style.display = "block";
            if (btn.parentElement) btn.parentElement.style.display = "block";
          });
        }
      }, 300);
    }
  }

  document.addEventListener("DOMContentLoaded", initPDP);
})();

/* --- Force product media to show + activate first thumbnail --- */
(function () {
  if (!/product/i.test(document.body.className + ' ' + document.documentElement.className)) return;

  var revealCSS = `
    .product__media,
    .product-gallery__main,
    .product-media__main,
    .product__main-media,
    .product-media { opacity:1!important; visibility:visible!important; }
    .product__media .media, .product-gallery__main .media { opacity:1!important; visibility:visible!important; }
    .product__media img, .product-gallery__main img, .product-media__main img, 
    .product__media video, .product-gallery__main video, .product-media__main video { opacity:1!important; visibility:visible!important; }
  `;
  var s = document.createElement('style'); s.textContent = revealCSS; document.head.appendChild(s);

  function revealMain() {
    document.querySelectorAll(
      '.product__media, .product-media__main, .product-gallery__main, .product__main-media'
    ).forEach(function (el) {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      el.style.display = '';
    });

    // Force autoplay for any product videos
    document.querySelectorAll('.product__media video, .product-gallery__main video, .product-media__main video').forEach((vid) => {
      vid.setAttribute('autoplay', 'true');
      vid.setAttribute('muted', 'true');
      vid.setAttribute('playsinline', 'true');
      vid.setAttribute('loop', 'true');
      vid.muted = true; // ensure browsers allow autoplay
      vid.play().catch(err => console.warn("Autoplay blocked:", err));
    });
  }

  function clickFirstThumb() {
    var thumb = document.querySelector(
      '.product-thumbnails__item-link, .product-media__thumbnail, [data-thumbnail], .product__thumbnail, .swiper .thumbnail a'
    );
    if (thumb) {
      const mediaType = thumb.getAttribute("data-media-type");
      if (mediaType === "video" || mediaType === "external_video") {
        thumb.click(); // trigger video playback
      } else {
        try { thumb.dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true })); } catch(e){}
      }
      return true;
    }
    return false;
  }

  function init() {
    revealMain();
    var hasVariant = new URL(location.href).searchParams.get('variant');
    if (!hasVariant) {
      if (!clickFirstThumb()) setTimeout(init, 300);
    }
  }

  var tries = 0;
  var t = setInterval(function(){
    tries++; init();
    if (tries > 10) clearInterval(t);
  }, 300);

  new MutationObserver(revealMain).observe(document.body, { childList:true, subtree:true });
})();

// listen to varient change select SKU

  document.addEventListener('DOMContentLoaded', function() {
  const variantJson = document.querySelector('[data-variant-json]');
  const skuDisplay = document.querySelector('.variant-sku');
  
  // Parse the JSON data once
  const variants = JSON.parse(variantJson.innerHTML);

  // Listen for changes on the product form
  // Change 'form[action="/cart/add"]' if your theme uses a different form selector
  const productForm = document.querySelector('form[action^="/cart/add"]');

  if (productForm) {
    productForm.addEventListener('change', function() {
      // Find the currently selected variant ID from the URL or hidden input
      const urlParams = new URLSearchParams(window.location.search);
      const selectedId = urlParams.get('variant');

      if (selectedId) {
        // Find the variant object that matches the ID
        const matchedVariant = variants.find(v => v.id == selectedId);
        
        if (matchedVariant && matchedVariant.sku) {
          skuDisplay.innerText = matchedVariant.sku;
        } else {
          skuDisplay.innerText = "N/A"; // Fallback if SKU is empty
        }
      }
    });
  }
});
/* === PRODUCT TITLE: SMART COLOUR APPEND CONTROLLER === */
(function () {
  const TITLE_SELECTOR = '.product__title[data-base-title]';

  function getColourIndex(product) {
    if (!product?.options) return -1;
    return product.options.findIndex(opt =>
      /^color$|^colour$/i.test(opt)
    );
  }

  function getUniqueColours(product, colourIndex) {
    if (colourIndex === -1) return [];
    return [...new Set(
      product.variants
        .map(v => v.options?.[colourIndex])
        .filter(Boolean)
    )];
  }

  function updateTitle(variant, product) {
    const titleEl = document.querySelector(TITLE_SELECTOR);
    if (!titleEl || !variant || !product) return;

    const baseTitle = titleEl.dataset.baseTitle;
    if (!baseTitle) return;

    const colourIndex = getColourIndex(product);
    const uniqueColours = getUniqueColours(product, colourIndex);

    // ✅ Single colour or no colour → base title only
    if (colourIndex === -1 || uniqueColours.length <= 1) {
      titleEl.textContent = baseTitle;
      return;
    }

    const colourValue = variant.options?.[colourIndex];
    if (!colourValue) {
      titleEl.textContent = baseTitle;
      return;
    }

    // ✅ Prevent "Grey – Grey"
    if (baseTitle.toLowerCase().endsWith(colourValue.toLowerCase())) {
      titleEl.textContent = baseTitle;
      return;
    }

    // ✅ Correct behaviour
    titleEl.textContent = `${baseTitle} – ${colourValue}`;
  }

  document.addEventListener('variant:change', function (e) {
    setTimeout(() => {
      updateTitle(e.detail.variant, e.detail.product);
    }, 0);
  });
})();
